import { render, staticRenderFns } from "./CardTarjaEnqueteSportTVNews.vue?vue&type=template&id=219d2446&scoped=true"
import script from "./CardTarjaEnqueteSportTVNews.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteSportTVNews.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteSportTVNews.vue?vue&type=style&index=0&id=219d2446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219d2446",
  null
  
)

export default component.exports